import { mergePoundsAndOuncesIntoWeight } from '@/utils/unitConverters/weightConvertor'

export const OUNCES = { Name: 'Ounces', Abbreviation: 'oz' }
export const POUNDS = { Name: 'Pounds', Abbreviation: 'lbs' }

const mapPricingRateFromAPI = ({
  weightOunceStart,
  weightOunceEnd,
  zonePrices
}) => {
  return {
    weightRange: [weightOunceStart, weightOunceEnd],
    zonePrices
  }
}

const mapPricingPlanFromAPI = ({
  Pagination,
  pricingRates
}) => {
  // const { pageNumber, recordCount: totalCount, pageCount: totalPages } = Pagination
  const { pageNumber, recordCount: totalCount, pageCount: totalPages } = {}
  return {
    pagination: {
      pageNumber,
      totalPages,
      totalCount
    },
    pricingRates: pricingRates.map(mapPricingRateFromAPI)
  }
}

const mapWeightFromOuncesToPoundsText = (weight) => {
  const defaultWeightInPounds = '0 lbs 0 oz'

  if (!weight || isNaN(weight)) {
    return defaultWeightInPounds
  }

  const weightInPounds = parseInt(weight / 16, 10)
  const remainingOunces = weight % 16

  return `${weightInPounds} lbs ${remainingOunces} oz`
}

const mapWeightFromOuncesToPounds = (weight) => {
  const defaultWeightInPounds = 0

  if (!weight || isNaN(weight)) {
    return defaultWeightInPounds
  }

  const weightInPounds = weight / 16

  return weightInPounds.toFixed(1)
}

const weightMappers = {
  [OUNCES.Name]: (weight) => weight,
  [POUNDS.Name]: (weight) => mapWeightFromOuncesToPounds(weight)
}

const weightMappersText = {
  [OUNCES.Name]: (weight) => weight,
  [POUNDS.Name]: (weight) => mapWeightFromOuncesToPoundsText(weight)
}

const mapWroBoxForLabelQuoteToApi = ({
  length,
  height,
  width,
  weight
}) => {
  return {
    lengthInches: length,
    widthInches: width,
    heightInches: height,
    weightInOz: mergePoundsAndOuncesIntoWeight(weight)
  }
}

const mapWroAddressForLabelQuoteToApi = ({
  city,
  state,
  zipCode
}, fcId) => {
  return {
    city,
    state,
    zipCode,
    country: 'US',
    destinationFcId: fcId
  }
}

const mapLabelPricingResponseFromApi = ({
  pricingGroupId,
  pricingGroupName,
  totalPrice,
  totalWeight,
  zone,
  message,
  wroBoxPrices
}) => ({
  pricingGroupId,
  pricingGroupName,
  totalPrice,
  totalWeight,
  zone,
  message: message && mapLabelPricingMessageFromApi(message),
  wroBoxPrices: wroBoxPrices && Array.isArray(wroBoxPrices) ? wroBoxPrices.map(mapLabelPricingWroBoxFromApi) : [],
  totalBoxes: wroBoxPrices && Array.isArray(wroBoxPrices) ? wroBoxPrices.length : 0
})

const mapLabelPricingByShipOptionResponseFromApi = ({
  shipOptionId,
  totalPrice,
  totalWeight,
  zone,
  message,
  wroBoxPrices,
  currencyCode
}) => ({
  shipOptionId,
  pricingGroupName: '',
  totalPrice,
  totalWeight,
  zone,
  message: message && mapLabelPricingMessageFromApi(message),
  wroBoxPrices: wroBoxPrices && Array.isArray(wroBoxPrices) ? wroBoxPrices.map(mapLabelPricingWroBoxFromApi) : [],
  totalBoxes: wroBoxPrices && Array.isArray(wroBoxPrices) ? wroBoxPrices.length : 0,
  currencyCode
})

const mapLabelPricingMessageFromApi = ({
  success,
  pricingMessage
}) => ({
  success,
  pricingMessage
})

const mapLabelPricingWroBoxFromApi = ({
  dimensionalWeight,
  heightInches,
  lengthInches,
  message,
  price,
  weightInOz,
  widthInches
}) => ({
  dimensionalWeight,
  heightInches,
  lengthInches,
  message: mapLabelPricingMessageFromApi(message),
  price,
  weightInOz,
  widthInches
})

const mapQuotesFromPricingApi = (quotes) => ({ quotes: quotes.map(mapQuoteFromPricingApi) })

const mapQuoteFromPricingApi = ({
  shipOptionId,
  totalPrice,
  currencyCode
}) => ({
  quoteId: '',
  shipmentId: '',
  quoteAmount: totalPrice,
  carrier: '',
  carrierService: '',
  currencyCode,
  shipOptionId
})

const mapToGetQuotesForReturn = ({
  name,
  fromAddress,
  fulfillmentCenter,
  inventory,
  returnDimensions
}) => ({
  originAddress: mapAddressToGetQuotes({ ...fromAddress, name }),
  fulfillmentCenterId: fulfillmentCenter.id,
  parcels: mapParcelsToGetQuotes({ returnDimensions, inventory })
})

// For returns there is only ever 1 parcel
const mapParcelsToGetQuotes = ({
  returnDimensions
}) => ([
  {
    dimensions: {
      lengthInches: returnDimensions.length.value,
      widthInches: returnDimensions.width.value,
      heightInches: returnDimensions.depth.value
    },
    weightOunces: returnDimensions.totalWeight.value
  }
])

const mapAddressToGetQuotes = ({
  street1,
  streetAddress1,
  street2,
  streetAddress2,
  city,
  state,
  country,
  zipCode,
  name
}) => ({
  street1: street1 || streetAddress1,
  street2: street2 || streetAddress2,
  city,
  state,
  countryISO: country,
  zipCode,
  name
})

export default {
  mapPricingPlanFromAPI,
  weightMappers,
  weightMappersText,
  mapWroBoxForLabelQuoteToApi,
  mapWroAddressForLabelQuoteToApi,
  mapLabelPricingResponseFromApi,
  mapLabelPricingByShipOptionResponseFromApi,
  mapQuotesFromPricingApi,
  mapToGetQuotesForReturn
}
